import { Skeleton } from '@mui/material'
import ArrowsCompareIcon from 'assets/arrows-compare.svg?react'
import PieChartIcon from 'assets/pie-chart.svg?react'
import MenuIcon from 'assets/trade.svg?react'
import { Statistic } from 'components/core-v2'

import classes from './index.module.scss'

export const TradeEventsStatisticsLoading = () => (
  <>
    <div className={classes.statSection}>
      <div className={classes.heading}>
        <MenuIcon />
        <h3>Overview</h3>
      </div>
      <Statistic.Wrapper>
        <Statistic.Header>Total account value</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>
      <Statistic.Wrapper>
        <Statistic.Header>Inflight orders</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>
    </div>

    <div className={classes.statSection}>
      <div className={classes.heading}>
        <PieChartIcon />
        <h3>Assets</h3>
      </div>
      <Statistic.Wrapper>
        <Statistic.Header>Performance</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>

      <Statistic.Wrapper>
        <Statistic.Header>Protection</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>
    </div>

    <div className={classes.statSection}>
      <div className={classes.heading}>
        <ArrowsCompareIcon />
        <h3>Clearing provision</h3>
      </div>
      <Statistic.Wrapper>
        <Statistic.Header>Cash</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>
      <Statistic.Wrapper>
        <Statistic.Header>Leveraged amount</Statistic.Header>
        <Statistic.Stat>
          <Skeleton height="21px" variant="text" width="100px" />
        </Statistic.Stat>
      </Statistic.Wrapper>
    </div>
  </>
)
